export const boxAspectRatio = 5 / 3;
export const threshhold = 0.6;
export const galleryPhotos = 5;
